import React from "react";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-3xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
        <p className="text-sm text-gray-500 mb-6">
          <strong>Last Updated:</strong> 4 April 2026<br />
          <strong>Trading Name:</strong> VSENDS<br />
          <strong>Legal Entity:</strong> V CAN RESOURCES LIMITED<br />
          <strong>Company Number:</strong> 13759348<br />
          <strong>Registered Office:</strong> 32 Abbey Drive, Dartford, England, DA2 7WP<br />
          <strong>Support Email:</strong> support@vsends.com<br />
          <strong>Compliance Email:</strong> vg@vcanresources.com
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">1. Introduction</h2>
        <p className="text-gray-700 mb-4">
          This Cookie Policy explains how V CAN RESOURCES LIMITED ("we", "us", "our") uses cookies and similar technologies on the VSENDS platform and website. It explains what these technologies are, why we use them, and your rights to control them.
        </p>
        <p className="text-gray-700 mb-4">
          Cookies are small data files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the site owners. We use both first-party cookies (set by us) and third-party cookies (set by our service providers).
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">2. Types of Cookies We Use</h2>
        <p className="text-gray-700 mb-4">
          We use the following categories of cookies:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li><strong>Strictly Necessary Cookies:</strong> Essential for the Service to function properly. These cannot be switched off.</li>
          <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with the Service by collecting anonymous, aggregated information.</li>
          <li><strong>Functional Cookies:</strong> Enable enhanced functionality and personalisation, such as remembering your preferences.</li>
          <li><strong>Targeting Cookies:</strong> Used to deliver relevant advertisements and measure the effectiveness of our marketing campaigns.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">3. Strictly Necessary Cookies</h2>
        <p className="text-gray-700 mb-4">
          These cookies are essential for the operation of the Service. They enable core functionality such as security, network management, and account access. You may disable these by changing your browser settings, but this may affect the functionality of the Service.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li>Session cookies to maintain your login state.</li>
          <li>CSRF tokens to protect against cross-site request forgery attacks.</li>
          <li>Load balancing cookies to distribute traffic across servers.</li>
          <li>Authentication cookies to verify your identity.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">4. Performance Cookies</h2>
        <p className="text-gray-700 mb-4">
          Performance cookies allow us to count visits and traffic sources so we can measure and improve the performance of the Service. They help us know which pages are the most and least popular and see how visitors move around the site.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li>Google Analytics cookies to analyse website traffic and usage patterns.</li>
          <li>Server log cookies to track page load times and error rates.</li>
          <li>A/B testing cookies to evaluate different versions of the Service.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          All information collected by these cookies is aggregated and anonymous. If you do not allow these cookies, we will not know when you have visited our site.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">5. Functional Cookies</h2>
        <p className="text-gray-700 mb-4">
          Functional cookies enable the Service to provide enhanced functionality and personalisation. They may be set by us or by third-party providers whose services we have added to our pages.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li>Language preference cookies to remember your selected language.</li>
          <li>Theme cookies to remember your display preferences.</li>
          <li>Form autofill cookies to remember information you have previously entered.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          If you do not allow these cookies, some or all of these services may not function properly.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">6. Third-Party Cookies</h2>
        <p className="text-gray-700 mb-4">
          Some cookies are placed by third parties on our behalf. These third parties have their own privacy policies and cookie policies. We do not control these cookies and recommend reviewing the relevant third-party policies.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li><strong>Google Analytics:</strong> For website analytics and performance monitoring.</li>
          <li><strong>Stripe:</strong> For payment processing and fraud prevention.</li>
          <li><strong>Intercom:</strong> For customer support and live chat functionality.</li>
          <li><strong>Cloudflare:</strong> For security and content delivery.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">7. Cookie Duration</h2>
        <p className="text-gray-700 mb-4">
          Cookies can remain on your device for different periods of time:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li><strong>Session cookies:</strong> These are temporary and are deleted when you close your browser.</li>
          <li><strong>Persistent cookies:</strong> These remain on your device for a set period or until you delete them. Our persistent cookies typically expire between 30 days and 2 years, depending on their purpose.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">8. Managing Your Cookie Preferences</h2>
        <p className="text-gray-700 mb-4">
          You have several options for managing cookies:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
          <li><strong>Browser settings:</strong> Most web browsers allow you to control cookies through their settings. You can usually find these settings in the "Options" or "Preferences" menu of your browser.</li>
          <li><strong>Cookie consent banner:</strong> When you first visit our website, you will be presented with a cookie consent banner where you can accept or reject non-essential cookies.</li>
          <li><strong>Opt-out links:</strong> Some third-party cookies can be managed through industry opt-out pages, such as www.aboutads.info/choices or www.youronlinechoices.com.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          Please note that blocking or deleting cookies may affect the functionality of the Service and your user experience.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">9. Updates to This Cookie Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update this Cookie Policy from time to time to reflect changes in technology, regulation, or our business practices. Any changes will be posted on this page with an updated "Last Updated" date.
        </p>
        <p className="text-gray-700 mb-4">
          If we make material changes, we will notify you by email or through a prominent notice on our website. We encourage you to review this policy periodically.
        </p>
        <p className="text-gray-700 mb-4">
          For questions about our use of cookies, please contact us at vg@vcanresources.com.
        </p>
      </main>
    </div>
  );
}
